import React, {
  useContext, useEffect, useState, createRef, useCallback,
} from 'react';
import {
  Card, InputAdornment, TextField, withStyles,
} from '@material-ui/core';
import { withI18n } from 'react-i18next';
import withWidth, { } from '@material-ui/core/withWidth';
import classnames from 'classnames';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { PageTitle } from 'gatorcomponents';
import { EmailsContext } from '@/contexts/Emails/context';
import ModalFreeTitanActiveSuccess from '@/components/Modal/ModalFreeTitanActiveSuccess';
import ModalMoveCPanelSuccess from '@/components/Modal/ModalMoveCPanelSuccess';
import { queryParams } from '@/utils/Application/queryParams';
import { IconSearch } from '@/icons/iconSearch';
import styles from './styles';
import { Popover } from '@/components/Popover';
import { PopoverContent } from '@/components/Popover/PopoverContent';
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { AI_AGENTS_EMAIL_PAGE_BANNER } from '@/config/GrowthBook/constants';

const ProEmailTitle = ({ classes, t, displaySearch }) => {
  const {
    typpedTerm, handleTyppedTerm,
  } = useContext(EmailsContext);
  const dispatch = useDispatch();

  const location = useLocation();
  const isFreemiumActivate = queryParams(location.search, 'frActivate');
  const isCPanelActivate = queryParams(location.search, 'cpActivate');
  const domain = queryParams(location.search, 'domain');
  const [isTrialActivate, setTrialActivate] = useState(queryParams(location.search, 'trialSucess'));
  const [modalFreeTitanActiveSuccess, setModalFreeTitanActiveSuccess] = useState(isFreemiumActivate);
  const [modalMoveCPanelSuccess, setModalMoveCPanelSuccess] = useState(isCPanelActivate);
  const guideRef = createRef(null);
  const showAIAgentBanner = useFeatureIsOn(AI_AGENTS_EMAIL_PAGE_BANNER);

  const { isIframeOpen } = useSelector(state => state.merlin);

  const getPageTitleProps = () => {
    const headButton = {
      label: t('proEmail.newEmailButton'),
      buttonVariant: 'primary',
      buttonSize: 'medium2',
      fullWidthHead: true,
      onClick: () => {
        const targetUrl = `${t('routes.emails')}${t('routes.createEmail')}${domain ? `/${domain}` : ''}`;
        window.location.href = targetUrl;
      },
    };

    return {
      testId: 'pro-email-page-title',
      title: t('lists.emails'),
      headButton,
      hideFilter: true,
    };
  };

  useEffect(() => {
    if (isTrialActivate) {
      setTrialActivate(false);
    }
  }, [dispatch, isTrialActivate]);

  const getPopoverProps = useCallback(() => ({
    title: t('proEmail.popover.title'),
    description: t('proEmail.popover.description'),
    buttonLabel: t('proEmail.popover.buttonLabel'),
  }), [t]);

  const popoverContent = <PopoverContent {...getPopoverProps()} />;

  const steps = [
    {
      popover: {
        key: 'domainsBannerButton',
        content: popoverContent,
        pointer: 'topRight',
        $maxWidth: 240,
      },
      mask: {
        customRadius: 100,
      },
    },
  ];

  const popoverStorageKey = 'notShowEmailsBannerPopover';
  const notShowBannerPopover = localStorage.getItem(popoverStorageKey) || isIframeOpen || !showAIAgentBanner;

  return (
    <>
      {!notShowBannerPopover && <Popover steps={steps} guideRef={guideRef} storageKey={popoverStorageKey} />}
      <div className={classnames(classes.cardsWrappers, !displaySearch ? classes.cardsWrappersWithoutSearch : '')}>

        <ModalFreeTitanActiveSuccess
          onClose={() => setModalFreeTitanActiveSuccess(false)}
          open={modalFreeTitanActiveSuccess}
          domain={domain}
        />

        <ModalMoveCPanelSuccess
          onClose={() => setModalMoveCPanelSuccess(false)}
          open={modalMoveCPanelSuccess}
          domain={domain}
        />

        <div className={classes.pageTitleContainer}>
          <PageTitle {...getPageTitleProps()} />
        </div>

        {displaySearch && (
        <Card className={classnames(classes.card, classes.middleCard)}>

          <TextField
            className={classes.textField}
            name="typedTerm"
            variant="outlined"
            required
            id="filterBy"
            value={typpedTerm}
            onChange={e => handleTyppedTerm(e.target.value)}
            InputProps={{
              startAdornment: <InputAdornment className={classnames(classes.iconSearch)} position="start"><IconSearch /></InputAdornment>,
            }}
            placeholder={t('proEmail.searchDomainLabel')}
          />
        </Card>
        )}

      </div>
    </>
  );
};

export default withI18n()(withWidth()(withStyles(styles)(ProEmailTitle)));
